import { IParamsToSend } from '@base/@types/providers/Budget/Commercial'

export const reportRequest: IParamsToSend = {
  empresa: {
    ids: [],
    agrupar: true
  },
  loja: {
    ids: [],
    agrupar: false
  },
  categoriaCompacta: {
    ids: [],
    agrupar: false
  },
  categoria: {
    ids: [],
    agrupar: true
  },
  gerenteCategoria: {
    ids: [],
    agrupar: false
  },
  gerenteProduto: {
    ids: [],
    agrupar: false
  },
  ano: {
    ids: [],
    agrupar: false
  },
  mes: {
    ids: [],
    agrupar: false
  },
  historico: {
    ids: [],
    agrupar: false
  }
}
